import AppConfig from '../../app.config';

/*  
  Place all common messages here. Each message needs "translationKey"
  and "default". "translationKey" is the namespace:key as found in
  service-i18n. "default" is the fallback text if no translation exists
  yet. Read the developer docs for more info.
*/
const messages = {
  load_error: {
    translationKey: 'common:page_load_error',
    default : 'An error occurred, please reload the page and if the problem persists contact {{- email}}.',
    additionalOptions: { replace: { email: `<a href='mailto:support@campbellcloud.io'>support@campbellcloud.io</a>` }, interpolation: { escapeValue: false } }
  },
  action_fail_advice: { translationKey: `common:action_fail_advice`, default: `Please try again and if the problem persists contact {{- email}}`, additionalOptions: { replace: { email: `<a href='mailto:${AppConfig.support_email}'> ${AppConfig.support_email}</a>` }, interpolation: { escapeValue: false } } },
  notifications: {
    buttons: {
      confirm: { translationKey: `${AppConfig.application_name}:button.continue`, default: 'Continue' },
      cancel: { translationKey: `common:button.cancel`, default: `Cancel` },
      removeConfirm: { translationKey: `wsms:popup.remove_confirm_button`, default: `Yes, remove` },
      removeCancel: { translationKey: `wsms:popup.remove_cancel_button`, default: `No, keep` }
    },
    title: {
      error: { translationKey: `common:single_word.error`, default: `Error` },
      success: { translationKey: `common:single_word.success`, default: `Success` },
      warning: { translationKey: `common:single_word.attention`, default: `Attention` },
      form_invalid: { translationKey: `${AppConfig.application_name}:form_error_title`, default: `Form validation error!` }
    },
  },
  buttons: {
    cancel: { translationKey: 'common:button.cancel', default: 'Cancel' },
  }
};
  
export default messages;